
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Star } from 'lucide-react';

interface SkillRating {
  [key: string]: number;
}

interface AssessmentSummaryProps {
  summary: string;
  aiRating: number;
  skillRatings: SkillRating;
}

const AssessmentSummary = ({ summary, aiRating, skillRatings }: AssessmentSummaryProps) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Assessment Summary</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="bg-secondary/30 p-4 rounded-md">
          <p className="text-muted-foreground">{summary}</p>
        </div>
        
        <div className="mt-6">
          <div className="flex items-center justify-between mb-2">
            <h3 className="font-medium">Overall Rating</h3>
            <div className="flex items-center">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  key={star}
                  size={18}
                  className={`${
                    star <= Math.floor(aiRating)
                      ? 'text-yellow-400 fill-yellow-400'
                      : star <= aiRating
                      ? 'text-yellow-400 fill-yellow-400 opacity-50'
                      : 'text-gray-300'
                  }`}
                />
              ))}
              <span className="ml-2 font-medium">{aiRating.toFixed(1)}</span>
            </div>
          </div>
          
          <Separator className="my-4" />
          
          <h3 className="font-medium mb-4">Skills Assessment</h3>
          {Object.entries(skillRatings).map(([skill, rating]) => (
            <div key={skill} className="mb-4">
              <div className="flex justify-between mb-1">
                <span className="text-sm">{skill}</span>
                <span className="text-sm font-medium">{rating}%</span>
              </div>
              <div className="w-full bg-secondary h-2 rounded-full">
                <div
                  className="bg-roundone-purple h-2 rounded-full"
                  style={{ width: `${rating}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default AssessmentSummary;
